import { useDispatch as orginalUseDispatch } from 'react-redux';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'store/types/RootState';

export type ThunkAppDispatch = ThunkDispatch<RootState, void, Action>;

export const useDispatch = () => orginalUseDispatch<ThunkAppDispatch>();
